export const DEFAULT_TENANT = "nordpool";

export function resolveCurrentTenant(host: string): string {
    const subdomain = host.split(".")[0];
    const tenantExtract = subdomain.match(/^(.*?)-.*$/);
    return tenantExtract ? tenantExtract[1] : DEFAULT_TENANT;
}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Branding/TenantResolver.ts